import get from 'lodash.get';
import { getClassNameByCondition } from '../shared/commonUtils';
import {
    getCorrectMark,
    getInsertMark,
    getInsertSelfCorrectClassName,
    getOmitClassName,
    getOmitMark,
    getRepeatClassName,
    getSubstituteMark,
    isChoosenCorrectionWord,
    getSubstituteSelfCorrectClassName,
} from '../shared/marksBuilderUtils';
import { EVENT_TYPES } from '../../constants/shared/ProbeDetailsConstants';

const { USER_EVENT } = EVENT_TYPES;

export const getMarksBuilderConfiguration = (
    wordPosition,
    sentenceLength,
    endPosition,
    startPosition,
    numberPage,
) => {
    const paginationNumber = `00${numberPage}`.slice(-3);

    return {
        isEnd: wordPosition + 1 === sentenceLength,
        isEndOfReading: endPosition === wordPosition,
        isStartOfReading: wordPosition === startPosition,
        paginationItem: `<Page ${paginationNumber}>`,
    };
};

export const getTroMarksClassNames = ({
    marks = [],
    startPosition = null,
    endPosition = null,
    wordPosition = null,
    isEnd = false,
    isItalic = false,
    isNotRead = false,
    activeWordPosition = null,
    isInsertToolbar = false,
    isCommonToolbar = false,
    isEndTimeToolbar = false,
    isEditMode = false,
}) => {
    const insertMark = getInsertMark(marks);
    const substituteMark = getSubstituteMark(marks);
    const omitMark = getOmitMark(marks);
    const correctMark = getCorrectMark(marks);
    const isActiveWord = wordPosition === activeWordPosition;

    const isInsertUserEvent = insertMark && insertMark.eventDetails.source === USER_EVENT;
    const isSubUserEvent = substituteMark && substituteMark.eventDetails.source === USER_EVENT;
    const isOmitUserEvent = omitMark && omitMark.eventDetails.source === USER_EVENT;

    const { repeatClassName, insertRepeatClassName } = getRepeatClassName(
        marks,
        wordPosition,
        isEnd,
    );
    const italicClassName = getClassNameByCondition(isItalic, 'font-italic');
    const notReadClassName = getClassNameByCondition(
        isNotRead || wordPosition < startPosition || wordPosition > endPosition,
        'not-read',
    );
    const userCorrectionClassName = getClassNameByCondition(
        isSubUserEvent || isOmitUserEvent,
        'user-correction',
    );
    const correctedClassName = getClassNameByCondition(
        !get(correctMark, 'eventDetails.endIsInsert', true) || isOmitUserEvent,
        'corrected-pencil',
    );
    const correctionClassName = getClassNameByCondition(
        !isChoosenCorrectionWord(endPosition, wordPosition),
        'out-of-range-correction',
    );
    const insertClassName = getClassNameByCondition(
        isInsertUserEvent,
        'ins-text user-correction corrected-pencil',
        'ins-text',
    );
    const substituteTextClassName = getClassNameByCondition(
        isSubUserEvent,
        'sub-text corrected-pencil',
        'sub-text',
    );
    const activeWordClassName =
        isActiveWord && (isCommonToolbar || isEndTimeToolbar) ? 'active-word' : '';
    const activeInsertWordClassName = isActiveWord && (isInsertToolbar ? 'active-word' : '');
    const canChosen = isEditMode ? 'can-chosen' : '';

    return {
        insertClassName,
        correctedClassName,
        userCorrectionClassName,
        repeatClassName,
        insertRepeatClassName,
        wordClassName: italicClassName + notReadClassName,
        omitClassName: getOmitClassName(marks),
        substituteSelfCorrectClassName: getSubstituteSelfCorrectClassName(marks),
        insertSelfCorrectClassName: getInsertSelfCorrectClassName(marks, isEnd),
        substituteTextClassName,
        correctionClassName,
        activeWordClassName,
        activeInsertWordClassName,
        canChosen,
    };
};
